import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from "../../../components/Seo";

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import { GetCourseWidget } from "../../../components/GetCourseWidget";
import { FooterMedium } from "../../../components/FooterMedium";

import {
  Screen1,
  Marathon,
  Decide,
  Gifts,
  Program,
  Timetable,
  ResultsAfter,
  ResultsStudents,
  RevsText,
  Speakers,
  Neuro,
  RevsVids,
  Graduate,
  Smi,
  Reg
} from "../../../components/LandingTemplates/marafon_motivacii_i_obuchenija_detej_v2";

const TITLE = 'Марафон мотивации и обучения детей';
const DESCRIPTION = 'Марафон мотивации и обучения детей - бесплатный 5-дневный марафон. Ребенок научится самостоятельно выполнять домашние задания! | Центр образовательных технологий Advance';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION} gcCounter={true}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = (
  {
    widgetFree=<GetCourseWidget hash={'53de8910c66034c21a89f924839616617775e386'} id={'1220812'}/>,
    widgetFreeHorizontal=<GetCourseWidget hash={'9a5c9cb627164572d3511dd41cabb7bf83983357'} id={'1220814'}/>,
    widgetFreeGrid=<GetCourseWidget hash={'3778c81e16ede2c9274a7e5ae3fe3c71b2404b6f'} id={'1220813'}/>,
  }) => {
  return <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <main>
      <Screen1 id={'emndu_v2'} widgetFree={widgetFree} />
      <Marathon/>
      <Decide/>
      <Gifts widgetFree={widgetFreeHorizontal}/>
      <Program/>
      <Timetable id={'emndu_v2'} widgetFree={widgetFreeGrid}/>
      <ResultsAfter widgetFree={widgetFreeHorizontal}/>
      <ResultsStudents/>
      <RevsText/>
      <Speakers/>
      <Neuro widgetFree={widgetFree}/>
      <RevsVids/>
      <Graduate/>
      <Smi/>
      <Reg id={'emndu_v2'} widgetFree={widgetFree}/>
    </main>

    <FooterMedium/>

  </DefaultLayout>
};
export default Page;
